import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import { NineCellLoading } from 'react-loadingg';
import 'moment/locale/it';
import '../../widgets/css/style.css';
import translateString from "../../utils/Locales";
import SelectInput from '../../widgets/SelectInput';
import getAppMinVersion from "../../services/getAppMinVersion";
import setAppMinVersion from "../../services/setAppMinVersion";

let t = translateString;

export default class AdminSettings extends React.Component {

  constructor(props){
    super (props)

    this.selectRef = React.createRef();

    this.state = {
      isLoading: true,
    }

  }

  async componentDidMount(){

    var min = await getAppMinVersion();
    min = min[0];

    this.selectVersioni = [];
    this.selectVersioni.push({ value: '1.0.0', label: '1.0.0' });
    this.selectVersioni.push({ value: '1.0.1', label: '1.0.1' });

    this.setState({ isLoading: false, version: { value: min.min_version, label: min.min_version} });
    
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <div>
        <PageTitle title={t('impostazioni')} />

        <div>
            <SelectInput key={Math.random()} 
                ref={this.selectRef}
                value={this.state.version} 
                name={t('min_versione')} 
                options={this.selectVersioni} 
                onChange={async (option) => {

                    this.setState({ isLoading: true });
                    const cookies = new Cookies();
                    const username = cookies.get('username', { path: '/' });
                    const token = cookies.get('token', { path: '/' });

                    await setAppMinVersion(username, token, option.value);
                    this.setState({ isLoading: false, version: option });
                }}
              />
        </div>
      </div>
    );
  }

}


